import { isString } from "lodash";
import { BasicType, BlockManager, Element, ElementDefinition } from "..";
import { formateBasicBlockAttribute } from "./formateBasicBlockAttribute";

const whiteListKey = ["padding", "mode"];
export function getAdapterAttributesString(
  params: {
    node: {
      attributes: Parameters<
        ElementDefinition["render"]
      >[0]["node"]["attributes"];
      type: Element["type"];
    };
  },
  options?: {
    keepEmptyAttributes?: boolean;
    removeDefaultAttributes?: boolean;
    mode: "testing" | "production";
  }
) {
  const { node } = params;
  const keepEmptyAttributes = options?.keepEmptyAttributes ?? false;
  const removeDefaultAttributes = options?.removeDefaultAttributes ?? false;
  const attributes = { ...formateBasicBlockAttribute(node, options?.mode) };
  const elementDefinition = BlockManager.getBlockByType(node.type).defaultData
    .attributes;

  let attributeStr = "";
  for (const key in attributes) {
    const keyName = key as keyof typeof attributes;

    let val = attributes[keyName];
    if (isString(val)) {
      val = val?.trim();
    }
    const isBasicElement = Object.values(BasicType).includes(node.type as any);
    if (
      removeDefaultAttributes &&
      isBasicElement &&
      elementDefinition[keyName] === val &&
      !whiteListKey.includes(keyName)
    ) {
      continue;
    }
    if (isString(val)) {
      val = val.trim();
      if (keepEmptyAttributes || val) {
        const splitter = " ";
        attributeStr += `${key}="${val.replace(/"/gm, "").trim()}"` + splitter;
      }
    }
  }

  return attributeStr;
}
